var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512pt",
    height: "512pt",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m209.92 273.71v117.76c0 6.4727 3.0625 12.562 8.2578 16.426 5.1914 3.8633 11.91 5.043 18.109 3.1836l51.199-15.359c4.1836-1.2578 7.8555-3.8164 10.48-7.3086 2.625-3.4922 4.0664-7.7305 4.1094-12.098v-102.4l103.58-141.52c2.9922-4.0898 4.3594-9.1445 3.8359-14.188-0.51953-5.0391-2.8906-9.707-6.6523-13.102-3.7656-3.3945-8.6523-5.2734-13.719-5.2734h-266.24c-5.0664 0-9.9531 1.8789-13.719 5.2734-3.7617 3.3945-6.1328 8.0625-6.6523 13.102-0.52344 5.043 0.84375 10.098 3.8359 14.188zm138.8-133.12-80.695 110.29c-4.4883 6.1367-6.9102 13.543-6.9102 21.148v89.035l-10.238 3.0703v-92.16h-0.003906c-0.011718-7.5859-2.4336-14.969-6.9102-21.094l-80.691-110.08z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.0db811ef33a4f1916d41975aec930558.svg";
export { ForwardRef as ReactComponent };